import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ReferenceInfo } from '@blaze-shared/api-contracts-domain';

import { setTargetWorkflow } from './target-workflow.actions';

@Injectable({ providedIn: 'root' })
export class WorkflowReferenceNavigationService {
  private readonly store = inject(Store);

  openReference(reference: ReferenceInfo, options?: { openInNewTab?: boolean }): void {
    this.store.dispatch(
      setTargetWorkflow({
        workflow: reference,
        action: {
          type: 'open',
          redirect: true,
          openInNewTab: options?.openInNewTab ?? true,
        },
      }),
    );
  }
}
